import React from 'react'
import classNames from 'classnames'

export interface ChoiceProps {
  className?: string
  onClick: () => void
  text: string
}

const TagChoice = ({ text, className, onClick }: ChoiceProps) => {
  return (
    <button className={classNames('c-pill', className)} onClick={onClick}>
      <span>{text}</span>
    </button>
  )
}

export default TagChoice
